import { create } from 'zustand'

export type FocusCouponId = number | null

export const useFpCategoryPromotionStore = create<{
  focusCouponId: FocusCouponId
  setFocusCouponId: (focusCouponId: FocusCouponId) => void
}>()(set => ({
  focusCouponId: null,
  setFocusCouponId: (focusCouponId: FocusCouponId) => set({ focusCouponId }),
}))
